import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from '@selectors'
import { useLoadScript } from '@react-google-maps/api'
import Splash from '@components/splash/splash.component'

const AuthIsLoaded = ({ children }) => {
  const auth = useSelector(selectIsAuthenticated)

  const { isLoaded: mapsLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: ['marker']
  })

  const isComplete = auth && mapsLoaded

  return isComplete ? children : <Splash />
}

export default AuthIsLoaded
